import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const convertToAdaptive: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  onExit: assign<Context>({ confirmConvertingPlanModal: false }),
  invoke: {
    src: "changeToAdaptivePlan",
    onDone: {
      target: "#StudyPlan.edit_plan.idle",
      actions: assign((_ctx, evt) => ({
        studyPlan: evt.data.plan,
        hasUnsavedStudyPlanChanges: true
      }))
    },
    onError: {
      target: "idle",
      actions: assign({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("changeToAdaptivePlan", {
            messageData: ["convert your plan to adaptive"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
